<template lang="pug">
  validation-observer(ref='observer' tag='form')
    app-modal(
      :closeOutside="false",
      :titulo="'Atenção'",
      @closeModal="closeModal()",
      :width="800"
      :height="220"
      :hasButtonX="false"
    )
      template(slot="body")
        div
          el-row.message
            span {{ notificacao.mensagem }}
            el-col.margin-top(:lg="34", :md="34", :sm="34")
      template(slot="footer")
        div.buttons
          el-button.botaoOk(type="primary",key="botao-confirma",@click="ok()")
            |  Marcar como lido
</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import AppDisplay from '@/components/AppDisplay'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppModal,
    AppDisplay
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idUsuario: {
      type: Number
    },
    notificacao: {}
  },

  data () {
    return {
      message: {},
      notification: {}
    }
  },

  async created () {
    this.message = await this.getMessageNotification(this.idUsuario)
  },

  methods: {
    ...mapActions({
      getMessageNotification: 'notifications/getMessageNotification',
      updatedNotification: 'notifications/updatedNotification'
    }),

    async closeModal () {
      this.notification = await this.updatedNotification(this.notificacao.id)
      this.$emit('closeModal')
    },

    async ok () {
      this.closeModal()
    }

  }

}
</script>

<style scoped lang="scss">

  .buttons {
    text-align: right;
  }

  .botaoOk {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
  .margin-right {
    margin-right: 10px;
  }

  .title {
    margin-top: 20px;
    font-size: 18px;
    font-weight: bold;
  }

  .hr {
    margin-top: 3%;
  }
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppModalNotificacao.vue